import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHotelfabrik = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg2",
	width: 933.54669,
	height: 281.10666,
	viewBox: "0 0 933.54669 281.10666",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs6" }), /* @__PURE__ */ _jsx("g", {
		id: "g8",
		transform: "matrix(1.3333333,0,0,-1.3333333,0,281.10667)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "g10",
			transform: "scale(0.1)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m 849,601.82 v 331.071 c 0,43.988 12.41,79.469 37.258,106.449 24.836,26.96 57.488,40.45 97.937,40.45 37.615,0 68.295,-11.89 92.085,-35.66 23.77,-23.78 35.66,-56.251 35.66,-97.4 V 601.82 h 124.55 v 326.809 c 0,85.161 -17.21,150.451 -51.63,195.871 -34.43,45.41 -85.34,68.14 -152.76,68.14 h -5.32 c -46.143,0 -84.284,-10.83 -114.44,-32.47 -30.172,-21.66 -52.527,-52.88 -67.067,-93.68 -14.554,-40.82 -21.824,-89.611 -21.824,-146.381 H 849 V 1378.93 H 724.449 V 601.82 H 849",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path12"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M 1903.51,886.398 V 907 c 0,36.398 -6.92,71.762 -20.75,106.11 -13.84,34.33 -34.25,65.05 -61.22,92.19 -26.98,27.12 -59.44,48.58 -97.4,64.38 -37.98,15.79 -81.44,23.7 -130.41,23.7 -48.97,0 -92.61,-7.91 -130.94,-23.7 -38.32,-15.8 -70.79,-37.26 -97.4,-64.38 -26.62,-27.14 -46.84,-57.86 -60.68,-92.19 -13.84,-34.348 -20.76,-69.712 -20.76,-106.11 v -20.602 c 0,-36.41 6.74,-71.589 20.23,-105.589 13.47,-33.989 33.35,-64.379 59.61,-91.161 26.25,-26.777 58.55,-48.25 96.87,-64.378 38.33,-16.129 82.67,-24.211 133.07,-24.211 50.38,0 94.75,8.082 133.07,24.211 38.32,16.128 70.61,37.601 96.87,64.378 26.25,26.782 46.13,57.172 59.62,91.161 13.47,34 20.22,69.179 20.22,105.589 z m -124.55,10.301 c 0,-35.711 -7.28,-67.988 -21.82,-96.828 -14.56,-28.84 -35.66,-51.68 -63.34,-68.5 -27.68,-16.84 -61.05,-25.242 -100.07,-25.242 -39.04,0 -72.39,8.402 -100.07,25.242 -27.67,16.82 -48.8,39.66 -63.34,68.5 -14.55,28.84 -21.82,61.117 -21.82,96.828 0,36.391 7.45,69.02 22.36,97.86 14.9,28.851 36.19,51.671 63.87,68.511 27.68,16.81 60.68,25.23 99,25.23 38.33,0 71.33,-8.42 99,-25.23 27.68,-16.84 48.97,-39.66 63.88,-68.511 14.9,-28.84 22.35,-61.469 22.35,-97.86",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path14"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 2110.87,810.488 v 270.352 h 179.91 v 92.62 h -179.91 v 205.47 H 1992.7 v -205.47 h -102.19 v -92.62 H 1992.7 V 821.57 c 0,-55.398 8.34,-99.371 25.02,-131.859 16.67,-32.52 41.34,-55.41 73.99,-68.699 32.63,-13.301 72.74,-19.953 120.29,-19.953 h 86.23 V 714.09 h -95.81 c -29.11,0 -51.63,8.308 -67.6,24.93 -15.97,16.621 -23.95,40.441 -23.95,71.468",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path16"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 2733.5,623.871 c 36.2,15.188 66.17,36.957 89.96,65.309 23.77,28.32 39.55,61.5 47.37,99.511 h -116.04 c -5.68,-22.8 -21.29,-42.679 -46.84,-59.601 -25.55,-16.949 -58.2,-25.399 -97.93,-25.399 -39.76,0 -72.39,8.45 -97.94,25.399 -25.55,16.922 -44.36,40.07 -56.42,69.449 -12.08,29.371 -18.1,62.723 -18.1,100.039 0,39.391 6.02,73.602 18.1,102.622 12.06,29.03 30.5,51.84 55.35,68.42 24.84,16.59 55.71,24.88 92.62,24.88 35.48,0 64.94,-7.43 88.36,-22.29 23.42,-14.86 41.15,-35.94 53.22,-63.23 12.06,-27.308 18.1,-59.609 18.1,-96.929 l 34.07,41.469 h -424.76 v -81.899 h 508.85 v 48.731 c 0,48.359 -10.29,93.458 -30.87,135.278 -20.59,41.8 -51.46,75.83 -92.61,102.11 -41.17,26.25 -92.62,39.39 -154.36,39.39 -47.56,0 -89.26,-8.13 -125.08,-24.36 -35.85,-16.25 -65.47,-38.02 -88.89,-65.31 -23.42,-27.31 -40.99,-58.05 -52.7,-92.26 -11.71,-34.212 -17.56,-69.63 -17.56,-106.259 V 889.25 c 0,-35.949 5.85,-71.012 17.56,-105.219 11.71,-34.211 29.28,-64.972 52.7,-92.261 23.42,-27.309 53.57,-49.239 90.48,-65.829 36.89,-16.589 80.19,-24.882 129.88,-24.882 46.12,0 87.29,7.613 123.48,22.812",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path18"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 3075.2,601.059 v 777.871 h -264.63 l -57.24,-92.86 h 196.25 V 601.059 h 125.62",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 3840.02,882.02 v -57.989 c -1.43,-33.832 -8.7,-60.051 -21.82,-78.691 -13.14,-18.629 -29.64,-31.93 -49.5,-39.86 -19.88,-7.941 -40.82,-11.91 -62.81,-11.91 -37.63,0 -66.37,8.45 -86.23,25.371 -19.88,16.911 -29.81,39.508 -29.81,67.821 0,28.297 9.93,51.258 29.81,68.859 19.86,17.598 48.6,26.399 86.23,26.399 z m 119.23,83.871 c 0,52.459 -9.42,94.389 -28.21,125.809 -18.81,31.4 -46.61,56.58 -85.7,68.85 -21.15,6.65 -43.1,10.04 -65.17,11.7 -14.25,1.08 -28.54,1.58 -42.83,1.81 -14.01,0.23 -28.03,0.22 -42.04,0.19 -14.23,-0.03 -28.47,-0.11 -42.7,-0.04 -13.39,0.07 -26.78,0.17 -40.17,0.17 -13.39,0 -26.79,-0.05 -40.18,-0.13 -13.22,-0.09 -26.43,-0.11 -39.65,-0.18 -13.31,-0.08 -26.63,-0.23 -39.94,-0.21 -11.52,0.02 -23.04,0.16 -34.56,0.16 -14.65,0.04 -29.29,0.01 -43.93,0.01 -4.06,0 -8.12,0 -12.18,0 -12.03,0 -24.05,0 -36.08,0 -2.16,0 -4.32,0 -6.48,0 l -0.02,34.56 c 0,23.42 6.55,41.86 19.69,55.35 13.12,13.48 31.4,20.23 54.82,20.23 h 86.23 v 99 h -72.39 c -67.43,0 -118.69,-15.44 -153.82,-46.31 -35.14,-30.87 -52.7,-78.61 -52.7,-143.18 l 0.01,-19.65 h -83.6 v -92.61 h 83.67 l 0.34,-480.361 h 118.16 l -0.33,480.361 c 4.01,0 8.02,0 12.02,0 10.09,0 20.18,0 30.27,0 20.03,0 40.06,0 60.1,0 5.73,0 11.46,0 17.2,0 17.8,0 35.59,0 53.39,0 17.88,0 35.75,0 53.62,0 17.93,0 35.87,0 53.8,0 17.94,0 35.87,0 53.81,0 13.56,0 27.13,0.52 40.68,0.01 3.94,-0.15 7.88,-0.4 11.81,-0.78 4.03,-0.4 8.04,-0.96 12.02,-1.75 16.08,-3.19 31.38,-9.78 44.44,-19.74 3.39,-2.59 6.63,-5.38 9.69,-8.36 18.45,-17.96 27.68,-44.18 27.68,-78.691 V 961.75 h -130.94 c -50.4,0 -93.68,-6.57 -129.87,-19.672 -36.2,-13.117 -64.06,-32.797 -83.57,-59.019 -19.52,-26.239 -29.27,-59.379 -29.27,-99.399 0,-37.98 8.51,-70.59 25.55,-97.851 17.03,-27.278 41.15,-47.989 72.38,-62.129 31.23,-14.141 67.77,-21.231 109.65,-21.231 40.46,0 74.69,7.09 102.73,21.231 28.03,14.14 50.03,34.511 66,61.09 6.88,11.441 12.37,24.32 16.94,38.14 l -1.24,-121.851 h 99 l 1.87,364.832",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path22"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 4157.27,1086.1 v 292.08 h -124.55 l -0.85,-777.121 h 99 l 0.85,136.91 m 372.59,163.34 c 0,-38.098 -7.29,-71.86 -21.82,-101.297 -14.56,-29.442 -34.97,-52.461 -61.21,-69.082 -26.27,-16.629 -56.79,-24.942 -91.56,-24.942 -30.52,0 -59.26,6.582 -86.22,19.742 -26.98,13.149 -48.81,32.372 -65.47,57.661 -16.69,25.281 -25.02,55.578 -25.02,90.91 v 44.668 c 0,36.703 8.15,68.051 24.48,94.021 16.32,25.98 37.96,45.88 64.94,59.74 26.97,13.85 56.06,20.78 87.29,20.78 34.77,0 65.11,-7.97 91.02,-23.89 25.9,-15.94 46.31,-38.28 61.21,-67.01 14.91,-28.751 22.36,-62.52 22.36,-101.301 z m -372.59,-163.34 c 2.9,-6.598 5.65,-13.328 9.05,-19.508 20.92,-38.102 49.67,-67.191 86.23,-87.27 36.54,-20.082 78.24,-30.132 125.08,-30.132 41.87,0 79.84,7.632 113.91,22.863 34.06,15.219 63.34,36.18 87.82,62.848 24.49,26.66 43.11,57.308 55.89,91.949 12.77,34.621 19.16,72.019 19.16,112.203 v 20.777 c 0,40.16 -6.22,77.563 -18.63,112.201 -12.42,34.63 -30.52,64.94 -54.29,90.91 -23.79,25.97 -52.16,46.23 -85.16,60.78 -33,14.54 -69.73,21.81 -110.18,21.81 -44.02,0 -83.75,-9.35 -119.23,-28.05 -34.69,-18.27 -62.64,-46.12 -84.1,-83.25",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path24"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 4812.09,601.059 v 304.152 c 0,53.18 14.37,94.121 43.12,122.839 28.74,28.71 66.01,49.14 120.55,51.08 h 41.79 v 95.13 h -20.33 c -70.97,0 -124.45,-13.99 -160.64,-54.76 -36.2,-40.77 -54.29,-102.27 -54.29,-184.512 h 4.25 v 239.282 h -99 V 601.059 h 124.55",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path26"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M 5196.71,601.059 V 1174.27 H 5072.16 V 601.059 h 124.55",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 5191.92,1279.72 c 12.41,13.48 18.63,30.87 18.63,52.16 0,20.58 -6.22,37.8 -18.63,51.64 -12.43,13.83 -31.77,20.75 -58.02,20.75 -25.55,0 -44.54,-6.92 -56.95,-20.75 -12.43,-13.84 -18.63,-31.06 -18.63,-51.64 0,-21.29 6.2,-38.68 18.63,-52.16 12.41,-13.49 31.4,-20.23 56.95,-20.23 26.25,0 45.59,6.74 58.02,20.23",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path30"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 5576.81,929.77 203.64,244.5 h -132 L 5416.38,892.551 V 1378.18 H 5291.83 V 601.059 h 124.55 v 266.929 h 69.2 l 204.39,-266.929 h 142.65 L 5576.81,929.77",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 6014.58,1170.3 262.55,72.39 -40.03,130.52 -198.39,-76.57 15.66,210.57 h -139.22 l 15.67,-214.05 -198.39,80.05 -41.77,-132.26 203.61,-52.2 -132.26,-160.11 109.64,-81.788 142.93,223.448",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path34"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 6020.57,1159.84 94.8,-212.988 115.92,83.318 -207.25,132.19 -3.47,-2.52",
					style: {
						fill: "#eceae1",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path36"
				})
			]
		})
	})]
});
export default SvgHotelfabrik;
